import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFormModule } from 'src/app/core/dynamic-form/dynamic-form.module';

import { TestRoutingModule } from './test-routing.module';
import { TestComponent } from './test.component';
import { CustomSwitchModule } from 'src/app/core/custom-switch/custom-switch.module';
import { CustomCheckboxModule } from 'src/app/core/custom-checkbox/custom-checkbox.module';

import { GridTestComponent } from './grid-test/grid-test.component';
import { CustomGridModule } from 'src/app/core/custom-grid/custom-grid.module';

import { CustomTextAreaModule } from 'src/app/core/custom-text-area/custom-text-area.module';
import { CustomDividerModule } from 'src/app/core/custom-divider/custom-divider.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TabTestComponent } from './tab-test/tab-test.component';
import { CustomTabsModule } from 'src/app/core/custom-tabs/custom-tabs.module';
import { EditHistoryModule } from 'src/app/core/edit-history/edit-history.module';


import { CustomStepsModule } from 'src/app/core/custom-steps/custom-steps.module';

import { StyleTestComponent } from './style-test/style-test.component';

import { CustomFileUploaderModule } from 'src/app/core/custom-file-uploader/custom-file-uploader.module';

import { CustomFileDownloaderModule } from 'src/app/core/custom-file-downloader/custom-file-downloader.module';


@NgModule({
    declarations: [
        TestComponent,
        GridTestComponent,
        TabTestComponent,
        StyleTestComponent,

    ],
    imports: [
        CommonModule,
        TestRoutingModule,
        DynamicFormModule,
        CustomSwitchModule,
        CustomCheckboxModule,

        CustomGridModule,
        CustomTextAreaModule,

        CustomDividerModule,
        FormsModule,
        ReactiveFormsModule,
        CustomTabsModule,
        EditHistoryModule,

        CustomStepsModule,

        CustomFileUploaderModule,

        CustomFileDownloaderModule,

    ]
})
export class TestModule { }
